module.exports = __webpack_public_path__ + "img/9791189336288.578bb7ae.jpg";